import { Box, Button, Icon, Typography } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { faChevronDown } from "@outschool/icons";
import { Space } from "@outschool/ui-legacy-component-library";
import React from "react";

import { DemoClubProvider } from "../../../providers";
import { useClubPostAndCommentDefaultBackgroundColor } from "../Club";
import { LottieReact, loadLottieMap } from "../Lottie";
import { SampleClubPostActivity } from "./SampleClubPosts";
import SampleClubPostsCarousel from "./SampleClubPostsCarousel";

interface SampleClubPostsBanner {
  activity: SampleClubPostActivity;
  onLearnHowGroupsWorkClick: () => void;
}

export default function SampleClubPostsBanner({
  activity,
  onLearnHowGroupsWorkClick,
}: SampleClubPostsBanner) {
  return (
    <DemoClubProvider
      LottieReact={LottieReact}
      loadLottieMap={loadLottieMap}
      useClubPostAndCommentDefaultBackgroundColor={
        useClubPostAndCommentDefaultBackgroundColor
      }
      useClubPostAndCommentBackgroundColors={() => ({
        data: {
          clubPostAndCommentBackgroundColors: ["#255DAD"],
        },
        loading: false,
      })}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Space y={"large"} />
        <Typography variant="h3" sx={{ textAlign: "center" }} emphasized>
          What can learners do in this chat group?
        </Typography>
        <Space y={"medium"} />
        <Button
          variant="link"
          onClick={onLearnHowGroupsWorkClick}
          sx={{
            display: "flex",
          }}
        >
          <Typography variant="inherit">
            Learn how a chat group works
          </Typography>
          <Space x={"small"} />
          <Icon icon={faChevronDown} />
        </Button>
        <Space y={"medium"} />
        <SampleClubPostsCarousel activity={activity} useNarrowDisplay={true} />
      </Box>
    </DemoClubProvider>
  );
}
